<template>
    <span>
        <pazar-cloud-details></pazar-cloud-details>
        <!-- <pazar-cloud-modules></pazar-cloud-modules> -->
        <!-- <page-footer></page-footer> -->
    </span>
</template>

<script>
import PazarCloudDetails from '@/components/PazarCloudDetails';
// import PazarCloudModules from '@/components/PazarCloudModules';
// import PageFooter from '@/components/PageFooter';
export default {
    name: 'pazarCloud',
    components: {
        PazarCloudDetails,
        // PazarCloudModules,
        // PageFooter
    },
    methods: {
        // priceList() {
        //     let productCode = 'pazarcloud'
        //     this.$store.dispatch('getPriceList', productCode);
        // }
    },
    mounted: function () {
        // this.priceList();
    }
};
</script>
